import React from 'react';
import { Clock, Plus, Trash2, Save, RotateCcw } from 'lucide-react';
import { useAlert } from '../../../../context/AlertContext';
import { defaultVisitRoles } from '../../../../utils/loyalty';

const VisitRoles = ({ t, canEdit, rolesDraft, setRolesDraft, tenantData, handleSaveRoles, isSavingRoles }) => {
    const { showConfirm } = useAlert();

    const handleSaveWithConfirm = async () => {
        const confirmed = await showConfirm(
            'Bu değişiklik tüm müşterilerin rollerini etkileyebilir.',
            { title: 'Ziyaret Rollerini Kaydet', confirmText: 'Kaydet', type: 'warning' }
        );
        if (confirmed) {
            handleSaveRoles();
        } else {
            const original = tenantData?.visitRoles || tenantData?.visit_roles || [];
            setRolesDraft(JSON.parse(JSON.stringify(original)));
        }
    };

    return (
    <section className="card glass">
        <style>{`
            @media (max-width: 768px) {
                .visit-role-row { flex-direction: column !important; align-items: stretch !important; }
                .visit-role-row > div { flex: none !important; width: 100% !important; }
                .visit-role-row button { align-self: flex-end; }
                .settings-header-actions { width: 100% !important; flex-direction: row !important; justify-content: flex-start !important; }
                .settings-header-actions button { flex: 1; align-items: center; justify-content: center; }
            }
        `}</style>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '1.25rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Clock size={24} style={{ color: 'var(--primary)' }} />
                <div>
                    <h2 style={{ fontSize: '1.25rem', fontWeight: 700 }}>Ziyaret Sıklığı Rolleri</h2>
                    <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>Müşterilerin ziyaret sayılarına (puan yükleme) göre roller atayın.</p>
                </div>
            </div>
            <div className="settings-header-actions" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                {canEdit && (
                    <>
                        <button
                            onClick={() => {
                                const newRoles = [...rolesDraft, {
                                    id: Date.now().toString(),
                                    label: 'Yeni Rol',
                                    minVisits: 10,
                                    periodDays: 30,
                                    color: '#10b981'
                                }];
                                setRolesDraft(newRoles);
                            }}
                            className="btn-secondary"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.875rem', padding: '10px 16px', borderRadius: '14px', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-main)', fontWeight: 600 }}
                        >
                            <Plus size={18} /> {t('common.add')}
                        </button>
                        <button
                            onClick={async () => {
                                const confirmed = await showConfirm(
                                    'Tüm ziyaret rolleri fabrika ayarlarına döndürülecek. Devam etmek istiyor musunuz?',
                                    { title: 'Varsayılana Dön', confirmText: 'Sıfırla', type: 'warning' }
                                );
                                if (confirmed) setRolesDraft(JSON.parse(JSON.stringify(defaultVisitRoles)));
                            }}
                            style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 16px', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-muted)', borderRadius: '14px', fontSize: '0.875rem', fontWeight: 600 }}
                            title="Varsayılan ayarlara dön"
                        >
                            <RotateCcw size={15} /> Varsayılan
                        </button>
                        <button
                            onClick={() => setRolesDraft(JSON.parse(JSON.stringify(tenantData?.visitRoles || tenantData?.visit_roles || [])))}
                            style={{ padding: '10px 16px', background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-main)', borderRadius: '14px', fontSize: '0.875rem', fontWeight: 600 }}
                        >
                            Vazgeç
                        </button>
                        <button
                            onClick={handleSaveWithConfirm}
                            disabled={isSavingRoles}
                            className="btn-primary"
                            style={{ padding: '10px 24px', borderRadius: '14px', border: 'none', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700 }}
                        >
                            <Save size={18} />
                            {isSavingRoles ? t('common.saving') : t('common.save')}
                        </button>
                    </>
                )}
            </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {rolesDraft.map((role, index) => (
                <div key={role.id || index} className="card visit-role-row" style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', padding: '1rem', display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                    <div style={{ flex: 2 }}>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Rol Adı</label>
                        <input
                            type="text"
                            value={role.label}
                            onChange={(e) => {
                                const newRoles = [...rolesDraft];
                                newRoles[index].label = e.target.value;
                                setRolesDraft(newRoles);
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Süre (Gün)</label>
                        <input
                            type="number"
                            value={role.periodDays || 30}
                            onChange={(e) => {
                                const newRoles = [...rolesDraft];
                                newRoles[index].periodDays = parseInt(e.target.value) || 0;
                                setRolesDraft(newRoles);
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Min. Ziyaret</label>
                        <input
                            type="number"
                            value={role.minVisits}
                            onChange={(e) => {
                                const newRoles = [...rolesDraft];
                                newRoles[index].minVisits = parseInt(e.target.value) || 0;
                                setRolesDraft(newRoles);
                            }}
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>Renk</label>
                        <div style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', padding: '8px',
                            background: 'var(--bg-sidebar)', borderRadius: '10px', border: '1px solid var(--border)', minWidth: '90px'
                        }}>
                            <input
                                type="color"
                                value={role.color || '#10b981'}
                                onChange={(e) => {
                                    const newRoles = [...rolesDraft];
                                    newRoles[index].color = e.target.value.toUpperCase();
                                    setRolesDraft(newRoles);
                                }}
                                style={{ width: '100%', height: '28px', border: 'none', padding: 0, background: 'transparent', cursor: 'pointer', borderRadius: '4px' }}
                            />
                            <input
                                type="text"
                                value={role.color || ''}
                                placeholder="#HEX"
                                onChange={(e) => {
                                    let val = e.target.value.toUpperCase();
                                    if (val && !val.startsWith('#')) val = '#' + val;
                                    const newRoles = [...rolesDraft];
                                    newRoles[index].color = val;
                                    setRolesDraft(newRoles);
                                }}
                                style={{ border: 'none', background: 'transparent', fontSize: '0.75rem', padding: 0, width: '100%', textAlign: 'center', fontFamily: 'monospace', fontWeight: 700, outline: 'none', color: 'var(--text-main)' }}
                            />
                        </div>
                    </div>
                    <button
                        onClick={() => {
                            const newRoles = rolesDraft.filter((_, i) => i !== index);
                            setRolesDraft(newRoles);
                        }}
                        style={{ background: 'transparent', color: '#ef4444', padding: '10px' }}
                    >
                        <Trash2 size={20} />
                    </button>
                </div>
            ))}
        </div>
    </section>
    );
};

export default VisitRoles;